import { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import Navbar from "../components/Dashboard/Navbar";

const Dashboard = lazy(() => import("./dashboard"));
const LandingPage = lazy(() => import("./landing-page"));
const Wallet = lazy(() => import("./wallet"));
const TransactionHistory = lazy(() => import("./transaction-history"));
const BuyCrypto = lazy(() => import("./buy-crypto"));
const Login = lazy(() => import("./login"));
const SignUp = lazy(() => import("./signup"));
const ForgotPassword = lazy(() => import("./forgot-password"));
const ResetPassword = lazy(() => import("./reset-password"));
const ConvertCrypto = lazy(() => import("./convert-crypto"));
const Mining = lazy(() => import("./mining"));
const DepositCoin = lazy(() => import("./deposit-btc"));
const ConvertAmount = lazy(() => import("./convert-amount"));
const Withdraw = lazy(() => import("./withdraw"));
const Settings = lazy(() => import("./settings"));
const Notifications = lazy(() => import('./notifications'));
const Trade = lazy(() => import('./trade'))
const Markets = lazy(() => import('./markets'))

const AppRoutes = () => (
  <div className={`background`}>
    <Navbar coinValue="0.00780000" coinName="BTC" />
    <div className={`wrapper padding`}>
      <Route exact path='/dashboard' component={Dashboard} />
      <Route exact path='/wallet' component={Wallet} />
      <Route exact path='/transaction-history' component={TransactionHistory} />
      <Route exact path='/buy-crypto' component={BuyCrypto} />
      <Route exact path='/login' component={Login} />
      <Route exact path='/signup' component={SignUp} />
      <Route exact path='/forgot-password' component={ForgotPassword} />
      <Route exact path='/reset-password/:id' component={ResetPassword} />
      <Route exact path='/convert-crypto' component={ConvertCrypto} />
      <Route exact path='/mining' component={Mining} />
      <Route exact path='/deposit-btc' component={DepositCoin} />
      <Route exact path='/convert-amount' component={ConvertAmount} />
      <Route exact path='/withdraw' component={Withdraw} />
      <Route exact path='/settings' component={Settings} />
      <Route exact path='/notifications' component={Notifications} />
      <Route exact path='/trade' component={Trade} />
      <Route exact path='/markets' component={Markets} />
    </div>
  </div>
)

//need to add custom loader later on.
export const Routes = () => {
  return (
    <Suspense fallback={<h1>Loading...</h1>}>
      <Switch>
        <Route exact path='/' component={LandingPage} />
        <AppRoutes />
      </Switch>
    </Suspense>
  )
}